import React, { useRef, useState, version } from "react";
import { connect } from "react-redux";
import CustomScroll from "react-custom-scroll";
import {
  generateOneTimePasswordSecret,
  validateOneTimePasswordConfiguration,
} from "../../services/Management/UserProfileService";
import AuthCode from "react-auth-code-input";
import QRCode from "react-qr-code";

const cancelReset2FAConfigPath = "#";

const ProfileReset2FAConfig = (props) => {
  const { setMode, _ } = props;
  const [AcceptedWarning, setAcceptedWarning] = useState(false);
  const [TwoFACode, setTwoFACode] = useState("");
  const [generatedSecretKeyAuthUrl, setGeneratedSecretKeyAuthUrl] =
    useState("");
  const [generatedSecretKey, setGeneratedSecretKey] = useState("");
  const twoFACodeValid = TwoFACode.length === 6;
  const [codeVerified, setCodeVerified] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [authorised, setAuthorised] = useState(false);

  function generateSecretKey() {
    generateOneTimePasswordSecret({ IsSelfReset: true }).then((res) => {
      if (res != null) {
        setGeneratedSecretKeyAuthUrl(res.otpAuthUrl);
        setGeneratedSecretKey(res.secretKey);
        setAuthorised(true);
      } else {
        setMode("ViewEdit");
      }
    });
  }

  function validateOneTimePasswordMatches() {
    validateOneTimePasswordConfiguration({ oneTimePassword: TwoFACode }).then(
      (res) => {
        setCodeVerified(res);
        setHasError(!res);
      }
    );
  }

  function updateTwoFACode(e) {
    console.log(e);
    setHasError(false);
    setTwoFACode(e);
  }

  return (
    <>
      <CustomScroll heightRelativeToParent="100%" allowOuterScroll={true}>
        <h3>
          {codeVerified && (
            <i
              className="icon-omni-profile-arrow-left"
              onClick={() => setMode("ViewEdit")}
            />
          )}
          {!AcceptedWarning && (
            <i
              className="icon-omni-profile-arrow-left"
              onClick={() => setMode("ViewEdit")}
            />
          )}
          {_.TwoFAuth.SidebarMenu.Header}
        </h3>
        <>
          {!AcceptedWarning && (
            <div>
              <h4>{_.TwoFAuth.SidebarMenu.ConfirmationHeader}</h4>
              <div>
                <ul className="d-flex flex-column justify-content-between flex-grow-1 password-requirements">
                  <li key={1}>
                    <i
                      className={
                        "icon-omni-warning-circle omni-color-ocean-green"
                      }
                    />
                    {_.TwoFAuth.SidebarMenu.WarningOne}
                  </li>
                  <br></br>
                  <li key={2}>
                    <i
                      className={
                        "icon-omni-warning-circle omni-color-ocean-green"
                      }
                    />
                    {_.TwoFAuth.SidebarMenu.WarningTwo}
                  </li>
                  <br></br>
                  <li key={3}>
                    <i
                      className={
                        "icon-omni-warning-circle omni-color-ocean-green"
                      }
                    />
                    {_.TwoFAuth.SidebarMenu.WarningThree}
                  </li>
                  <br></br>
                  <li key={4}>
                    <i
                      className={
                        "icon-omni-warning-circle omni-color-ocean-green"
                      }
                    />
                    {_.TwoFAuth.SidebarMenu.WarningFour}
                  </li>
                </ul>
              </div>
              <div className="change-password-action">
                <button
                  className="btn form-control"
                  onClick={(e) => {
                    generateSecretKey();
                    setAcceptedWarning(!AcceptedWarning);
                  }}
                >
                  {_.Continue}
                </button>
                <a
                  href={cancelReset2FAConfigPath}
                  onClick={(e) => {
                    e.preventDefault();
                    setMode("ViewEdit");
                  }}
                >
                  {_.Cancel}
                </a>
              </div>
            </div>
          )}

          {AcceptedWarning && !codeVerified && authorised && (
            <div>
              <h4>{_.TwoFAuth.SidebarMenu.FollowInstructions}</h4>
              <div className="twoFAuth-qr-code-zone">
                <div className="qr-code">
                  {generatedSecretKeyAuthUrl.length > 0 && (
                    <QRCode
                      value={generatedSecretKeyAuthUrl}
                      style={{
                        height: "auto",
                        width: "100%",
                        maxWidth: "100%",
                      }}
                    />
                  )}
                </div>
                <div className="instruction-text">
                  {_.TwoFAuth.SidebarMenu.QRCodeInstructions}
                </div>
              </div>
              <div className="twoFAuth-manual-secret-input-text">
                {_.TwoFAuth.SidebarMenu.SecretKeyInstructions}
              </div>
              <div className="twoFAuth-secret-zone">
                <div className="secret-code">
                  <span className="icon lock-icon icon-omni-lock" />
                  {generatedSecretKey}
                </div>
              </div>
              <div>
                <form>
                  <div className="twoFAuth-code-management">
                    <div className="instruction-text">
                      {_.TwoFAuth.SidebarMenu.EnterCode}
                    </div>
                    <div className="input-container">
                      <AuthCode
                        containerClassName="input-container"
                        inputClassName={
                          "input-code" + (hasError ? "-with-error" : "")
                        }
                        allowedCharacters="numeric"
                        length={6}
                        onChange={(e) => updateTwoFACode(e)}
                      />
                    </div>
                  </div>
                  <div className="change-password-action">
                    <button
                      type="submit"
                      className="btn twoFAuth-confirm-btn-themed form-control"
                      disabled={!twoFACodeValid || hasError}
                      onClick={(e) => {
                        e.preventDefault();
                        validateOneTimePasswordMatches();
                      }}
                    >
                      {_.Confirm}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
          {codeVerified && (
            <div className="twoFAuth-complete-container">
              <div className="message-text">
                <p>
                  <i className="icon-omni-tick-circle" />
                </p>
                <p>{_.TwoFAuth.SidebarMenu.Success}</p>
                <p>
                  <span className="return-link">
                    <a
                      href={cancelReset2FAConfigPath}
                      onClick={(e) => {
                        e.preventDefault();
                        setMode("ViewEdit");
                      }}
                    >
                      {_.Close}
                    </a>
                  </span>
                </p>
              </div>
            </div>
          )}
        </>
      </CustomScroll>
    </>
  );
};

const mapStateToProps = (state) => state;

export default connect(mapStateToProps)(ProfileReset2FAConfig);
